import React from 'react'
import DateFormat from '../../shared/helpers/date-format'
import { Link } from 'react-router'
import { formatValueAsCurrency } from '../../shared/helpers/data-display-format'

const OrderDetailsCard = ({ order }) => {
  let { slashed, time } = DateFormat
  let giftCertificatesList
  let giftMembership
  let orderList
  let adoptionsList
  let contributionsList
  let paymentStatus
  let orderFeeList
  let membershipList
  let conversion

  const memberships = order.odMembershipLevel
  const orderFees = order.odOrderFees
  const giftCertificates = order.odGiftCertificates
  const giftMembershipLevels = order.odGiftMembershipLevel
  const adoptions = order.odAdoptions
  const contributions = order.odContributions
  const orderProducts = order.odProducts
  const isConversion = order.odIsConversion === 'Y'
  const isPledge = order.odIsPledge === 'Y'
  const pledgeDate = order.odPledgeDue

  const returnListCopy = (mappingElement, returnElement, textKey) => {
    if (mappingElement.length > 0) {
      return (returnElement = mappingElement.map(element => {
        const copy = {
          adoptionsKey: `${formatValueAsCurrency(
            element.contributionAmount
          )} Adopt a ${element.animalName}`,
          contributionsKey: `${formatValueAsCurrency(
            element.contributionAmount
          )} Contribution`,
          membershipsKey: `${element.membershipLevel} Membership`,
          giftMembershipsKey: `Gift Membership: ${element.giftMembershipLevel}`,
          orderFeesKey: `${element.feeDescription}`,
          giftCertificatesKey: `${formatValueAsCurrency(
            element.giftCertificateOriginalAmount
          )} Gift Card`
        }
        return (
          <li key={element?.contRefNo || Math.random(4)}>{copy[textKey]}</li>
        )
      }))
    }
  }

  if (orderProducts.length > 0) {
    orderList = orderProducts.map(product => {
      if (product.eventDetails.hasZones) {
        return (
          <li key={product.perfNo}>
            {product.eventDetails.title} {slashed(product.performanceDateTime)}{' '}
            - {product.zoneDisplayName}
          </li>
        )
      } else if (product.eventDetails.isTimed) {
        return (
          <li key={product.perfNo}>
            {product.eventDetails.title} {slashed(product.performanceDateTime)}{' '}
            - {time(product.performanceDateTime)}
          </li>
        )
      } else {
        return (
          <li key={product.perfNo}>
            {product.eventDetails.title} {slashed(product.performanceDateTime)}
          </li>
        )
      }
    })
  }

  if (order.odIsFullyPaid === 'yes' && order.odPaidInFullDate) {
    if (isPledge) {
      paymentStatus = `Payment completed on ${slashed(order.odPaidInFullDate)}`
    } else {
      paymentStatus = `Paid in full on ${slashed(order.odPaidInFullDate)}`
    }
  } else if (order.odIsFullyPaid === 'yes') {
    paymentStatus = 'Paid in full'
  } else {
    paymentStatus = <strong>Payment Incomplete</strong>
  }

  if (isConversion) {
    conversion = `Original order date ${slashed(order.odOrderDate)}`
  }

  function returnPledgeCopy() {
    if (order.odTotPaidAmt > 0) {
      return (
        <li>{`Pledged Contribution: ${formatValueAsCurrency(
          order.odTotPaidAmt
        )}`}</li>
      )
    } else {
      return (
        <li>{`Pledged Contribution: ${formatValueAsCurrency(
          order.odBalanceAmt
        )}`}</li>
      )
    }
  }

  return (
    <div
      id={order.odOrderNumber}
      className="bordered-content detail-card"
    >
      <p className="my-0">
        <strong> Order #{order.odOrderNumber}</strong>
        <br />
        {isPledge && (
          <span>
            {`Pledged Contribution due on ${slashed(pledgeDate)}`} <br />
          </span>
        )}
        {conversion}
        {isConversion && <br />}
        {paymentStatus}
      </p>

      {order.odOrderRefundedDate.trim() !== '' && (
        <div>
          <p className="m-0">
            {`Order Modified on ${slashed(order.odOrderRefundedDate)}`}
          </p>
        </div>
      )}

      {
        <ul
          className="bullet-list mt-0"
          data-testid={'order-history-order-list'}
        >
          {orderList}
          {returnListCopy(memberships, membershipList, 'membershipsKey')}
          {returnListCopy(
            giftMembershipLevels,
            giftMembership,
            'giftMembershipsKey'
          )}
          {returnListCopy(contributions, contributionsList, 'contributionsKey')}
          {returnListCopy(adoptions, adoptionsList, 'adoptionsKey')}
          {returnListCopy(
            giftCertificates,
            giftCertificatesList,
            'giftCertificatesKey'
          )}
          {returnListCopy(orderFees, orderFeeList, 'orderFeesKey')}
          {isPledge && returnPledgeCopy()}
        </ul>
      }

      <Link to={`/order_history/${order.odOrderNumber}`}>
        <button
          className="button -dark -medium mt-12"
          data-testid={'order-details-button'}
          data-id={order.odOrderNumber}
          data-order={order.odOrderNumber}
        >
          View Full Order
        </button>
      </Link>
    </div>
  )
}
export default OrderDetailsCard
